import React, { useState, useRef, useEffect } from 'react'
import { Icon, Input, Spin, Button, message, Upload, Collapse, Modal, Popover } from "antd"
import { getDetailPartner, getEmbroideryInfo, pushNewItemHistory } from '../../../services/api/3dApi'
import convertDateOverTime from '../../../helpers/convertDateOverTime'
import { updateStatusItemEmbroidery } from "../../../services/api/3dPartnerApi"
import ThreadColorImage from '../../batch/components/data/ThreadColorImage'
import { isAbsoluteUrl } from '../../batch/components/data/ThreadColorImage'
const { confirm } = Modal

export const downloadDst = async (fileUrl, desiredName = 'file.dst') => {
    if (!fileUrl) return message.error('Không có URL file để tải.')

    try {
        const resp = await fetch(fileUrl, {
            method: 'GET', mode: 'cors', headers: {
                // 'Access-Control-Allow-Origin': 'http://127.0.0.1'
            }
        })
        if (!resp.ok) throw new Error(`HTTP ${resp.status}`)

        const blob = await resp.blob()
        const blobUrl = URL.createObjectURL(blob)

        const a = document.createElement('a')
        a.href = blobUrl
        a.download = desiredName  // dùng tên file từ tham số
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)

        // Giải phóng blob sau 1.5s
        setTimeout(() => URL.revokeObjectURL(blobUrl), 1500)

    } catch (err) {
        console.warn('Download trực tiếp thất bại:', err)
        // Fallback: mở link trong tab mới
        console.error(
            'Không thể tải trực tiếp (có thể do CORS). Mở link trong tab mới để tải (tên file có thể khác).'
        )
        try { window.open(fileUrl, '_blank') } catch (e) { console.warn(e) }
    }
}

function EmbroideryPage(props) {
    const { currentTemplate } = props
    const template = currentTemplate ? `#${currentTemplate}` : ''
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const [data, setData] = useState({})
    const [previewOpen, setPreViewOpen] = useState(false)
    const [previewColorImage, setPreViewColorImage] = useState('')
    const [partnerCode, setPartnerCode] = useState('')

    const handlePreview = (file) => {
        setPreViewColorImage(file.url)
        setPreViewOpen(true)
    }

    const _input = useRef(null)

    useEffect(() => {
        if (template && template.trim()) {
            setValueInput(template.trim())
            fetchOrderDetail(template.trim())
        } else {
            setValueInput('')
            setData({})
        }
    }, [template])

    useEffect(() => {
        if (!!_input.current && !Object.keys(data).length) _input.current.focus()
    }, [loading, data])

    const _onSubmit = async (e) => {
        e.preventDefault()
        const check = /^#\d+_\d+$/.test(valueInput)

        if (!check) return setErrorInput('Item sai định dạng.')

        const valueFormatted = valueInput.trim()

        if (!valueFormatted) return setErrorInput('Item sai định dạng.')

        check && fetchOrderDetail(valueInput)
    }

    const _fetchPartner = async (id) => {
        try {

            const { data: response } = await getDetailPartner(id)

            const { data, success, error } = response

            if (!success) throw new Error(error)

            const { code = '' } = Object.assign({}, data)
            if (!!code) setPartnerCode(code)

        } catch (e) {
            message.error(e.message)
        }
    }

    const fetchOrderDetail = async (template) => {
        try {
            if (!template.trim()) {
                return
            }
            setLoading(true)
            setErrorInput('')
            setData({})

            const payload = {
                getBatch: true
            }

            const { data: response } = await getEmbroideryInfo(template.trim().replace(/^#/, ''), payload)

            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            // Kiểm tra đã QCHT (trạng thái completed)
            if (data.completed_at) {
                confirm({
                    title: 'Đơn đã QCHT',
                    content: 'Đơn này đã QCHT, xác nhận thêu lại?',
                    okText: 'Xác nhận',
                    cancelText: 'Hủy',
                    async onOk() {
                        try {
                            // Gọi API lưu log thêu lại
                            const { success, message: mess } = await pushNewItemHistory(template.trim().replace(/^#/, ''), {
                                event_key: 'confirm_re_embroidery',
                                event_description: `Confirm re-embroidery`,
                                event_meta: {
                                    source: 'confirm_re_embroidery',
                                }
                            })

                            if (!success) {
                                return message.error(mess || 'Save history failed!')
                            }

                            // Tiếp tục quy trình bình thường nếu save success
                            const { batch = {} } = data
                            const { partner = '' } = batch

                            if (partner) await _fetchPartner(partner)

                            setData(data)
                        } catch (err) {
                            message.error(err.message)
                        }
                    },
                    onCancel: () => {
                        // Nếu hủy, reset input hoặc không làm gì
                        setValueInput('')
                        setData({})
                    },
                })
                return // dừng ở đây nếu popup confirm
            }

            if (data.sub_status === 'cancel-ship') {
                alert(`Đơn đã bị hủy sản xuất`)
                setValueInput('')
                setData({})
                return
            }

            const { batch = {} } = { ...data }
            const { partner = '' } = { ...batch }
            if (partner) await _fetchPartner(partner)

            setData(data)

        } catch (e) {
            setData({})
            message.error(e.message)
        } finally {
            setLoading(false)
        }
    }

    const handleChangeScan = (e) => {
        const { value } = e.target
        setValueInput(value)
        setErrorInput('')
    }
    const resetScanInput = () => {
        setValueInput('')
        setErrorInput('')
        setData({})
        if (_input.current) {
            _input.current.focus()
        }
    }
    const transformDataToFileList = (data) => {
        return Array.isArray(data)
            ? data.map(cf => ({
                uid: cf.file_name,
                name: cf.file_name,
                status: 'done',
                url: cf.url,
            }))
            : []
    }

    // ----- đổi tên hiển thị khi isReuse === true -----
    const {
        barcode_number,
        item_number,
        mock_up_front,
        mock_up_back,
        embroidery_area_info = {},
        type,
        size,
        batch = {},
        preview_image,
        brand = {},
        meta = {},
        overtime,
        thread_color_note = '',
        production_status = '',
        safezone_image = ''
    } = data || {}
    const { embroidery_positions = [], embroidery_colors = {}, embroidery_files = {}, color_files = {}, reuse_from } = embroidery_area_info || {}
    const { org_barcode_item } = reuse_from || {}
    const isReuse = !!embroidery_area_info && embroidery_area_info.hasOwnProperty('reuse_from')
    const barcodeItem = isReuse ? `${barcode_number}_${item_number}` : ''

    const listFile = Object.entries(embroidery_files || {}).reduce(
        (acc, [side, files]) => {
            acc[side] = (files || []).map((fileObj, idx) => {
                const { file_name = '', url = '' } = fileObj || {}

                const originalName = file_name || (() => {
                    const m = url.match(/\/([^\/?#]+\.dst)(?:[?#].*)?$/i)
                    return m ? decodeURIComponent(m[1]) : `file_${side}_${idx}.dst`
                })()

                const extMatch = originalName.match(/(\.[^.?#]+)(?:[?#].*)?$/)
                const ext = extMatch ? extMatch[1] : '.dst'
                const sideSlug = String(side).replace(/\s+/g, '_')

                // nếu isReuse true và barcodeItem có giá trị -> tạo tên mới
                const displayName = isReuse && barcodeItem
                    ? `${barcodeItem}_${sideSlug}${idx ? ` (${idx})` : ''}${ext}`
                    : originalName

                return {
                    uid: `emb-${side.replace(/\s+/g, '_')}-${idx}-${Date.now()}`,
                    name: displayName, // tên hiện thị trên Upload list
                    status: 'done',
                    url,
                }
            })
            return acc
        },
        {}
    )
    const _updateStatusItemEmbroidery = async () => {
        try {
            const payload = {
                partnerCode,
                batchItems: !!template ? [template] : [valueInput]
            }

            const { success, message: error } = await updateStatusItemEmbroidery(payload)

            if (!success) throw new Error(error)

            message.success("Cập nhật trạng thái đã thêu thành công.")
            resetScanInput()

        } catch (e) {
            message.error(e.message)
        }
    }

    const { embroidery_sides = [] } = meta || {}
    const { basename: batchName } = batch || {}
    const listColor = embroidery_colors
    const { name: brandName } = brand || {}
    const embroiderySides = Array.isArray(embroidery_sides) && !!embroidery_sides.length ? embroidery_sides : (Array.isArray(embroidery_positions) && !!embroidery_positions.length ? embroidery_positions : [])
    const firstSideIndex = embroiderySides.findIndex(side => {
        const colors = listColor[side]
        const files = listFile[side]
        const hasColor = Array.isArray(colors) && colors.length > 0
        const hasFile = Array.isArray(files) && files.length > 0
        return hasColor || hasFile
    })

    return (
        <div className='EmbroideryPage'>
            <div className="position-relative">
                <Spin spinning={loading} tip='Đang kiểm tra...'>
                    <form onSubmit={_onSubmit} className="formQC">
                        <Input
                            value={valueInput.toUpperCase()}
                            style={{ fontSize: 40, height: "auto" }}
                            ref={_input}
                            autoFocus={true}
                            placeholder='Nhập vào item thêu'
                            onChange={handleChangeScan}
                            disabled={loading}
                        />
                        {valueInput &&
                            <Icon
                                type='close-circle'
                                className="position-absolute cursor-pointer text-dark IconInput"
                                onClick={resetScanInput}
                            />
                        }
                        {loading &&
                            <Icon type="sync" spin className="position-absolute IconInput" />
                        }
                    </form>

                    {errorInput && <div className="text-danger my-3">{errorInput}</div>}

                    {Object.keys(data).length > 0 &&
                        <div className="EmbroideryDetails mt-4 d-flex flex-wrap justify-content-start row">
                            <div className="col-lg-6 Images mb-4 d-flex flex-wrap justify-content-start align-items-start">
                                {(mock_up_front || mock_up_back) &&
                                    <div className='mr-5 mb-3 mockUp' style={{ maxWidth: 300 }}>
                                        <img src={mock_up_front || mock_up_back} alt="Mockup" />
                                    </div>
                                }
                                {preview_image &&
                                    <Popover
                                        content={
                                            <div className='position-relative'>
                                                <div className={`Preview position-relative PriviewFileIn`} >
                                                    <img src={preview_image} alt="Preview" className='position-absolute' style={{ width: '100%' }} />
                                                </div>
                                            </div>
                                        }
                                        trigger="hover"
                                        placement="right"
                                        overlayClassName='previewFixed'
                                    >
                                        <div className='mb-3 printFile position-relative' style={{ maxWidth: 450 }}>
                                            <img src={preview_image} alt="File in" className='position-absolute' style={{ cursor: 'pointer' }} />
                                            {
                                                !!safezone_image &&
                                                <img src={safezone_image} alt="Safezone" className='safezone-img' />
                                            }
                                            <div
                                                className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                                <span className='Icon cursor-pointer mr-2' onClick={() => {
                                                    setPreViewColorImage(preview_image)
                                                    setPreViewOpen(true)
                                                }}>
                                                    <Icon type='eye' />
                                                </span>
                                            </div>
                                        </div>
                                    </Popover>
                                }
                            </div>
                            <div className="col-lg-6 Info d-flex flex-wrap justify-content-start align-items-start">
                                <div className='mb-4 mx-4 batchInfo'>
                                    <h4 className='font-weight-bold'>{type}</h4>
                                    <h5 className='w-100' style={{ fontSize: 20, fontWeight: 600, color: '#000000a6' }}>{size}</h5>
                                    {batchName &&
                                        <h5 className='w-100' style={{ fontSize: 20, fontWeight: 600, color: '#000000a6' }}>{batchName}</h5>
                                    }
                                    {brandName &&
                                        <div>
                                            <span className='ant-btn my-2 ant-btn-danger ant-btn-lg' style={{ fontSize: 20, fontWeight: 600, height: 'unset', cursor: 'auto' }}>{brandName}</span>
                                        </div>
                                    }
                                    {!!overtime && overtime > 0 &&
                                        <h4
                                            className="mb-0 mt-2 btn"
                                            style={{
                                                background: 'rgba(255 77 80)',
                                                color: 'white', cursor: 'auto',
                                            }}
                                        >
                                            QUÁ HẠN <label
                                                className="font-weight-bold my-0">{convertDateOverTime(overtime)}</label>
                                        </h4>
                                    }
                                    {overtime < 0 && overtime >= -1.5 &&
                                        <h4
                                            className="mb-0 mt-2 btn"
                                            style={{
                                                background: '#ffcd3a',
                                                color: 'white', cursor: 'auto',
                                            }}
                                        >
                                            SẮP QUÁ HẠN <label
                                                className="font-weight-bold my-0">{convertDateOverTime(overtime)}</label>
                                        </h4>
                                    }
                                    {
                                        !!thread_color_note &&
                                        <div className="mt-2 h4" style={{ color: '#ee2b4f' }}>
                                            <div>Màu chỉ yêu cầu:</div>
                                            <div style={{ maxWidth: '350px' }}>
                                                {!!isAbsoluteUrl(thread_color_note) ?
                                                    <ThreadColorImage ImageUrl={thread_color_note} /> :
                                                    thread_color_note
                                                }
                                            </div>
                                        </div>
                                    }
                                    {
                                        production_status === 'designed' && !!partnerCode &&
                                        <div className="mt-2">
                                            <Button
                                                type='primary'
                                                size='large'
                                                style={{ width: '100%', fontSize: '24px' }}
                                                onClick={_updateStatusItemEmbroidery}
                                            >Đã thêu</Button>
                                        </div>
                                    }
                                </div>
                                {embroiderySides.length > 0 &&
                                    <div className='mb-4 ml-4 side'>
                                        <h4 className='font-weight-bold'>MẶT THÊU</h4>
                                        <Collapse
                                            bordered
                                            defaultActiveKey={[firstSideIndex]}
                                            expandIconPosition={'right'}
                                            style={{ width: 500 }}
                                        >
                                            {embroiderySides.length > 0 && embroiderySides.map((i, idx) => (
                                                <Collapse.Panel
                                                    header={<h5 className='w-100 mb-0 text-uppercase' style={{ fontWeight: 700, color: '#fff' }}>{i}</h5>}
                                                    key={idx}
                                                    className='w-100'
                                                >
                                                    {Array.isArray(listFile[i]) && listFile[i].length > 0 &&
                                                        <div className="embroideryFiles mb-4">
                                                            <h5 className='mr-3'>FILE THÊU:</h5>
                                                            <div className="listFile">
                                                                <Upload
                                                                    className={`uploadFileDST`}
                                                                    defaultFileList={listFile[i] || []}
                                                                    accept=".dst"
                                                                    onDownload={(file) => {
                                                                        downloadDst(file.url, file.name)
                                                                    }}
                                                                    disabled
                                                                    showUploadList={false}
                                                                />
                                                            </div>
                                                            {Array.isArray(listFile[i]) && listFile[i].length > 0 &&
                                                                <div className="embroideryFiles mb-4">
                                                                    <div className="listFile custom-file-list">
                                                                        {listFile[i].map(file => (
                                                                            <div key={file.uid} className="custom-file-item d-flex align-items-center">
                                                                                <div className="file-left d-flex align-items-center">
                                                                                    <Icon type="paper-clip" style={{ marginRight: 8, fontSize: 16 }} />
                                                                                    <a
                                                                                        href={file.url}
                                                                                        className="custom-file-link"
                                                                                        onClick={(e) => {
                                                                                            if (isReuse) {
                                                                                                e.preventDefault()
                                                                                                downloadDst(file.url, file.name)
                                                                                            }
                                                                                        }}
                                                                                        title={file.name}
                                                                                    >
                                                                                        {file.name}
                                                                                    </a>
                                                                                </div>

                                                                                <div className="file-right ml-auto">
                                                                                    <a
                                                                                        href={file.url}
                                                                                        className="download-action"
                                                                                        onClick={(e) => {
                                                                                            if (isReuse) {
                                                                                                e.preventDefault()
                                                                                                downloadDst(file.url, file.name)
                                                                                            }
                                                                                        }}
                                                                                        title="Download"
                                                                                    >
                                                                                        <Icon type="download" style={{ fontSize: 16 }} />
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                    {((!!Array.isArray(listColor[i]) && listColor[i].length > 0) || color_files[i]) &&
                                                        <div className='mb-4 embroideryColors'>
                                                            <div className="d-flex flex-wrap justify-content-between">
                                                                <h5 className=''>CÁC BƯỚC MÀU THÊU:</h5>
                                                                {!!color_files[i] &&
                                                                    <div
                                                                        className="UploadImage w-100"
                                                                    // style={{ width: 112, height: 112, overflow: 'hidden' }}
                                                                    >
                                                                        <Upload
                                                                            className={`UploadImages ${i}`}
                                                                            listType="picture-card"
                                                                            onPreview={handlePreview}
                                                                            fileList={transformDataToFileList(color_files[i] || [])}
                                                                            accept="image/*"
                                                                            onDownload={true}
                                                                            disabled={true}
                                                                            showUploadList={
                                                                                {
                                                                                    showDownloadIcon: true,
                                                                                    downloadIcon: 'Download',
                                                                                    showRemoveIcon: false,
                                                                                    showPreviewIcon: true,
                                                                                }
                                                                            }
                                                                            style={{ width: 120, height: 120 }}
                                                                        />
                                                                    </div>
                                                                }
                                                            </div>
                                                            {!!Array.isArray(listColor[i]) && listColor[i].length > 0 &&
                                                                <div className="listColor d-flex flex-wrap justify-content-start">
                                                                    <div className="list1 d-flex flex-column mr-5">
                                                                        {listColor[i].map((color, colorIdx) => (
                                                                            colorIdx < (listColor[i].length % 2 === 0 ? listColor[i].length / 2 : Math.ceil(listColor[i].length / 2)) &&
                                                                            <span key={`color_${colorIdx}`} style={{ fontSize: 20, fontWeight: 600 }}>{`${colorIdx + 1}. ${color}`}</span>
                                                                        ))}
                                                                    </div>
                                                                    <div className="list2 d-flex flex-column">
                                                                        {listColor[i].map((color, colorIdx) => (
                                                                            colorIdx >= (listColor[i].length % 2 === 0 ? listColor[i].length / 2 : Math.ceil(listColor[i].length / 2)) &&
                                                                            <span key={`color_${colorIdx}`} style={{ fontSize: 20, fontWeight: 600 }}>{`${colorIdx + 1}. ${color}`}</span>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    }
                                                </Collapse.Panel>
                                            ))}
                                        </Collapse>
                                    </div>
                                }
                                <Modal
                                    visible={previewOpen}
                                    title={'Preview image'}
                                    footer={null}
                                    onCancel={() => setPreViewOpen(false)}
                                >
                                    <img
                                        alt="preview"
                                        style={{ width: '100%' }}
                                        src={previewColorImage}
                                    />
                                </Modal>
                            </div>
                        </div>
                    }
                </Spin>
            </div >
        </div >
    )
}

export default EmbroideryPage